define(["marionette", "messaging/messenger", "./landlordInfoView"], function (
  Marionette,
  Messenger,
  LandlordInfoView,
) {
  var LandlordInfoController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "landlordInfo";
      this.region = options.region;
      this.landlord = options.model;
      this._setUpVents();
    },
    show: function () {
      this.view = new LandlordInfoView.landlordInfoLayout();

      this.showRegion(this.view);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:landlord:profile:info",
        function () {
          this.show();
        },
        this,
      );
    },
  });

  return LandlordInfoController;
});
